// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__2bCEC","contentWrapper":"styles_contentWrapper__1n-XB","searchIcon":"styles_searchIcon__jxNkr"};